import { useCaptureEvent } from "@Light/app/analytics";
import { Button } from "@Light/components/page/Button";
import { ButtonFooter } from "@Light/components/page/ButtonFooter";
import { zip5 } from "@Light/utils/address";
import { EnrollBottomSheet } from "../common/EnrollBottomSheet";
import { EnrollHelpButton } from "../EnrollHelpButtonFooter";

export type ZipUtilityIneligibleBottomSheetProps = {
  open: boolean;
  postalCode: string;
  onClose: () => void;
};

export const ZipUtilityIneligibleBottomSheet = ({
  open,
  postalCode,
  onClose,
}: ZipUtilityIneligibleBottomSheetProps) => {
  useCaptureEvent({
    event: "enroll_zip_ineligible_viewed",
    condition: open,
    properties: { variant: "sheet", postal_code: postalCode },
  });

  return (
    <EnrollBottomSheet
      open={open}
      onClose={onClose}
      title={
        <span data-testid="zip-utility-ineligible-sheet-heading">
          Sorry, but we don&rsquo;t provide service to {zip5(postalCode)}
        </span>
      }
      subtitle="This is either in an area where customers can’t choose providers or we haven’t launched there yet."
      data-testid="zip-utility-ineligible-sheet"
      footer={
        <ButtonFooter>
          <Button
            size="lg"
            className="w-full"
            onClick={onClose}
            data-testid="zip-utility-ineligible-sheet-retry"
          >
            Use a different zip code
          </Button>
          <EnrollHelpButton
            onClick={onClose}
            eventVariant="zip_utility_ineligible_sheet"
          >
            Is this incorrect? Reach out to us
          </EnrollHelpButton>
        </ButtonFooter>
      }
    />
  );
};
